var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-1" }, [
    _c("div", { staticClass: "col-sm-3" }, [
      _c(
        "h6",
        { staticClass: "mb-0" },
        [
          _c("font-awesome-icon", {
            staticClass: "text-primary mr-2",
            attrs: { icon: ["fad", _vm.icon], "fixed-width": "" }
          }),
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-sm-9 text-primary" },
      [
        _vm.file
          ? [
              _c("span", [
                _c(
                  "a",
                  {
                    staticClass: "file-link",
                    on: {
                      click: function($event) {
                        return _vm.downloadFile(_vm.file)
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fad", "download"] }
                    }),
                    _vm._v("\n          - " + _vm._s(_vm.file.name))
                  ],
                  1
                )
              ])
            ]
          : [_vm._v(" / ")]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }